// extracted by mini-css-extract-plugin
export var btn = "UpdateCustomerInfo-module--btn--QhZy2";
export var component = "UpdateCustomerInfo-module--component--54yUu";
export var form = "UpdateCustomerInfo-module--form--aOhwQ";
export var formWrapper = "UpdateCustomerInfo-module--formWrapper--4fAge";
export var info = "UpdateCustomerInfo-module--info--xyAtG";
export var link = "UpdateCustomerInfo-module--link--2Vz-k";
export var loader = "UpdateCustomerInfo-module--loader--4UM10";
export var roundIcon = "UpdateCustomerInfo-module--roundIcon--FUDd7";